import { InputLabel, TextField } from '@mui/material'
import { DatePicker as MUIDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import React from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker'
import moment from 'moment/moment'

const DatePicker = ({
    label,
    value,
    onChange,
    onBlur,
    disabled,
    error,
    helperText,
    labelTop,
    notFullWidth,
    shouldDisableDate,
    minDate,
    placeholderAsLabel = false,
    hasHour = false,
    clearToday
}) => {
    return !hasHour ? (
        <LocalizationProvider dateAdapter={AdapterDayjs} sx={error && { border: '1px solid #d32f2f' }}>
            {disabled ? (
                <MUIDatePicker
                    disabled
                    minDate={minDate}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    inputFormat="DD/MM/YYYY"
                    sx={error && { border: '1px solid #d32f2f' }}
                    componentsProps={{
                        actionBar: { actions: ['clear', 'today'] },
                    }}
                    shouldDisableDate={shouldDisableDate}
                    renderInput={(params) => (
                        <div>
                            {!disabled || (placeholderAsLabel && <InputLabel>{label}</InputLabel>)}
                            <TextField
                                {...params}
                                size="small"
                                label={labelTop && label}
                                error={error}
                                helperText={helperText}
                                sx={
                                    error
                                        ? {
                                            border: '1px solid #d32f2f',
                                            width: notFullWidth ? '93%' : '100%',
                                            color: 'black',
                                            backgroundColor: 'hsl(0, 0%, 95%)',
                                        }
                                        : {
                                            width: notFullWidth ? '93%' : '100%',
                                            color: 'black',
                                            backgroundColor: 'hsl(0, 0%, 95%)',
                                        }
                                }
                            />
                        </div>
                    )}
                />
            ) : (
                <MUIDatePicker
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    minDate={minDate}
                    inputFormat="DD/MM/YYYY"
                    shouldDisableDate={shouldDisableDate}
                    sx={error && { border: '1px solid #d32f2f' }}
                    componentsProps={{
                        actionBar: { actions: [!clearToday && 'today', 'accept'] },
                    }}
                    disabled={disabled}
                    renderInput={(params) => (
                        <div>
                            {!labelTop && <InputLabel>{label}</InputLabel>}
                            <TextField
                                {...params}
                                size="small"
                                label={labelTop && label}
                                error={error}
                                helperText={helperText}
                                disabled={disabled}
                                sx={
                                    error
                                        ? {
                                            border: '1px solid #d32f2f',
                                            width: notFullWidth ? '93%' : '100%',
                                        }
                                        : { width: notFullWidth ? '93%' : '100%' }
                                }
                            />
                        </div>
                    )}
                />
            )}
        </LocalizationProvider>
    ) : (
        <LocalizationProvider dateAdapter={AdapterDayjs} sx={error && { border: '1px solid #d32f2f' }}>
            <MobileDateTimePicker
                label={label}
                value={value}
                componentsProps={{
                    actionBar: { actions: ['cancel', !clearToday && 'today', 'accept'] },
                }}
                disabled={disabled}
                shouldDisableDate={shouldDisableDate}
                ampm={false}
                inputFormat="DD/MM/YYYY HH:mm"
                minDate={minDate}
                onChange={(e) => {
                    onChange(moment(new Date(e)).format('YYYY-MM-DDTHH:mm:ss'))
                }}
                renderInput={(params) => (
                    <div>
                        {!labelTop && <InputLabel>{label}</InputLabel>}
                        <TextField
                            {...params}
                            size="small"
                            label={labelTop && label}
                            error={error}
                            helperText={helperText}
                            disabled={disabled}
                            sx={
                                disabled
                                    ? {
                                        color: 'black',
                                        backgroundColor: 'hsl(0, 0%, 95%)',
                                        width: notFullWidth ? '93%' : '100%',
                                    }
                                    : error
                                        ? {
                                            border: '1px solid #d32f2f',
                                            width: notFullWidth ? '93%' : '100%',
                                        }
                                        : { width: notFullWidth ? '93%' : '100%' }
                            }
                        />
                    </div>
                )}
            />
        </LocalizationProvider>
    )
}

export default DatePicker